// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/scale.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/scale'

import { Icon, type IconComponentProps } from '../icon'

export const ScaleIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
